import { getActiveTimezone } from './tz';

// Date-only values (YYYY-MM-DD, e.g. lease dates) are calendar dates and must NOT shift
// by timezone. Full timestamps are rendered in the account's province timezone.
export const formatDate = (value, withTime = false) => {
  if (!value) return '—';
  const s = typeof value === 'string' ? value.trim() : value;
  const dateOnly = typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s);
  const opts = { month: 'short', day: 'numeric', year: 'numeric' };
  let d;
  if (dateOnly) {
    const [y, m, dd] = s.split('-').map(Number);
    d = new Date(y, m - 1, dd);
  } else {
    d = new Date(s);
    opts.timeZone = getActiveTimezone();
  }
  if (Number.isNaN(d.getTime())) return '—';
  if (withTime) { opts.hour = 'numeric'; opts.minute = '2-digit'; }
  return d.toLocaleDateString('en-CA', opts);
};
